const ResourceCenterWithIndicator = ({
  width = '24',
  height = '24',
  className = '',
  title = '',
  stroke = '1.5',
  role = ''
}): React.ReactNode => {
  const hidden = title && title.length > 0 ? false : true;
  if (width === '16' && height === '16') {
    return (
      <svg
        width="19"
        height="17"
        viewBox="0 0 19 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden={`${hidden}`}
        role={role ? role : hidden ? 'graphics-document' : 'img'}
      >
        {!hidden && <title>{title}</title>}
        <path
          d="M11.7333 4.11082C12.7071 3.95432 13.6914 3.87236 14.6777 3.86566C14.7624 3.86436 14.8443 3.89656 14.9054 3.95526C14.9654 4.0134 14.9995 4.09323 15 4.17677V13.988C14.9983 14.1591 14.86 14.2974 14.6889 14.2991C9.5288 14.3632 8 15.999 8 15.999V5.56557C8 5.56557 6.47244 3.93162 1.32231 3.86566C1.23713 3.86403 1.15478 3.89625 1.09333 3.95526C1.0338 4.01361 1.00018 4.09341 1 4.17677V13.988C1.00169 14.1591 1.13999 14.2974 1.31111 14.2991C6.4712 14.3632 8 15.999 8 15.999"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        />
        <path
          d="M8 15.6926C8.09831 14.8862 8.4555 14.1334 9.01796 13.5472C9.74172 12.7665 10.6909 12.2308 11.7333 12.0147V2.30614C11.7314 2.20446 11.678 2.11072 11.5915 2.05725C11.4998 1.99964 11.3877 1.98466 11.2841 2.01618C10.411 2.26706 9.62585 2.75794 9.01796 3.43298C8.45574 4.01885 8.09857 4.77117 8 5.57716"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        />
        <circle cx="15.8" cy="3.11104" r="2.3" fill="#BA1E50" stroke="white" />
      </svg>
    );
  }
  return (
    <svg
      width="29"
      height="24"
      viewBox="0 0 29 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke="#000000"
      aria-hidden={`${hidden}`}
      role={role ? role : hidden ? 'graphics-document' : 'img'}
    >
      {!hidden && <title>{title}</title>}
      <path
        d="M17.3333 5.01583C18.7245 4.79227 20.1306 4.67518 21.5396 4.66561C21.6606 4.66375 21.7775 4.70975 21.8649 4.79361C21.9506 4.87667 21.9993 4.99071 22 5.11006V19.1261C21.9976 19.3705 21.8 19.5681 21.5556 19.5705C14.184 19.6621 12 21.9989 12 21.9989V7.09406C12 7.09406 9.81778 4.75983 2.46044 4.66561C2.33876 4.66328 2.22112 4.70931 2.13333 4.79361C2.04829 4.87697 2.00026 4.99097 2 5.11006V19.1261C2.00241 19.3705 2.19999 19.5681 2.44444 19.5705C9.816 19.6621 12 21.9989 12 21.9989"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M12 21.5609C12.1404 20.4089 12.6507 19.3334 13.4542 18.496C14.4882 17.3807 15.8441 16.6154 17.3333 16.3067V2.43734C17.3306 2.29208 17.2542 2.15817 17.1307 2.08178C16.9997 1.99949 16.8395 1.97808 16.6916 2.02312C15.4443 2.38152 14.3226 3.08277 13.4542 4.04712C12.6511 4.88407 12.1408 5.95882 12 7.11023"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <circle cx="24" cy="5" r="4" fill="#BA1E50" stroke="white" strokeWidth="2" />
    </svg>
  );
};

export default ResourceCenterWithIndicator;
